if (!HTMLCanvasElement.prototype._patched) {
    const originalGetContext = HTMLCanvasElement.prototype.getContext;

    HTMLCanvasElement.prototype.getContext = function (type, attributes) {
        if (type === '2d') {
            attributes = Object.assign({}, attributes, { willReadFrequently: true });
        }

        return originalGetContext.call(this, type, attributes);
    };

    HTMLCanvasElement.prototype._patched = true;
}

import { createApp } from 'vue';
import './axios';
import VueTheMask from 'vue-the-mask';
import { createVfm } from 'vue-final-modal'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import 'vue-final-modal/style.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import { InstallCodeMirror } from "codemirror-editor-vue3";

import Vistoriar from './vue/src/Vistoria/Vistoriar.vue';
import Vistoria from './vue/src/Vistoria/Vistoria.vue';
import DocConfiguration from './vue/src/Docs/DocConfiguration.vue';
import DocEmissao from './vue/src/Docs/DocEmissao.vue';
import Docs from './vue/src/Docs/Docs.vue';
import ptBR from 'ant-design-vue/es/locale/pt_BR';
import DocHistory from "./vue/src/Docs/DocHistory.vue";
import Zoneamento from "./vue/src/Viabilidade/Zoneamento/Zoneamento.vue";
import UsosSolo from "./vue/src/Viabilidade/UsosSolo/UsosSolo.vue";
import CreateUpdateUsosSolo from "./vue/src/Viabilidade/UsosSolo/CreateUpdateUsosSolo.vue";
import Siglas from "./vue/src/Viabilidade/Siglas/Siglas.vue";
import CreateUpdateSiglas from "./vue/src/Viabilidade/Siglas/CreateUpdateSiglas.vue";
import ViewHtmlSiglas from "./vue/src/Viabilidade/Siglas/ViewHtmlSiglas.vue";
import ViewHtmlUsosSolo from "./vue/src/Viabilidade/UsosSolo/ViewHtmlUsosSolo.vue";
import Browser from "./vue/src/Components/Browser.vue";
import OcupacoesSolo from "./vue/src/Viabilidade/OcupacoesSolo/OcupacoesSolo.vue";
import CreateUpdateOcupacoesSolo from "./vue/src/Viabilidade/OcupacoesSolo/CreateUpdateOcupacoesSolo.vue";
import ViewHtmlOcupacoesSolo from "./vue/src/Viabilidade/OcupacoesSolo/ViewHtmlOcupacoesSolo.vue";
import VueMenu from "./vue/src/Layouts/VueMenu.vue";
import Menus from "./vue/src/Configurations/Menus/Menus.vue"
import Users from "./vue/src/Configurations/Users/Users.vue"
import CreateUpdateUser from "./vue/src/Configurations/Users/CreateUpdateUser.vue";
import ChangePassword from "./vue/src/Configurations/Users/ChangePassword.vue";
import Login from "./vue/src/Configurations/Auth/Login.vue";
import UsersGroups from "./vue/src/Configurations/UsersGroups/UsersGroups.vue";
import CreateUpdateGroupsUsers from "./vue/src/Configurations/UsersGroups/CreateUpdateGroupsUsers.vue";
import FAQ from "./vue/src/Configurations/Faqs/FAQ.vue";
import CreateUpdateFAQs from "./vue/src/Configurations/Faqs/CreateUpdateFAQs.vue";
import ClientImages from "./vue/src/Configurations/ClientImages/ClientImages.vue";
import CreateUpdateClientImages from "./vue/src/Configurations/ClientImages/CreateUpdateClientImages.vue";
import TableView from "./vue/src/Components/TableView.vue";
import TypesService from "./vue/src/Viabilidade/TypesService/TypesService.vue";
import CreateUpdateTypesService from "./vue/src/Viabilidade/TypesService/CreateUpdateTypesService.vue";
import Bic from "./vue/src/Components/MapActions/Bic/Bic.vue";
import Home from "./vue/src/Home.vue";
import WelcomeMap from "./vue/src/MapsOpenLayers/Welcome/WelcomeMap.vue";
import CreateUpdateVistoria from "./vue/src/Vistoria/CreateUpdateVistoria.vue";
import ViabilityMap from "./vue/src/MapsOpenLayers/Viability/ViabilityMap.vue";
import StreetView from "./vue/src/MapsOpenLayers/Components/StreetView.vue";
import ShowVistorias from "./vue/src/Vistoria/ShowVistorias.vue";
import VistoriaCard from "./vue/src/Vistoria/VistoriaCard.vue";
import VistoriaOld from "./vue/src/Vistoria/VistoriaOld.vue";
import ScheduleVistoria from "./vue/src/Vistoria/ScheduleVistoria.vue";
import SpecificFunctionalities from "./vue/src/Configurations/SpecificFunctionalities/SpecificFunctionalities.vue";
import Layers from "./vue/src/Maps/Layers/Layers.vue";
import CreateUpdateLayers from "./vue/src/Maps/Layers/CreateUpdateLayers.vue";
import LayerViewer from "./vue/src/Components/LayerViewer.vue";
import PublicLayerViewer from "./vue/src/Components/PublicLayerViewer.vue";
import CreateUpdateThematicLayers from "./vue/src/Maps/ThematicLayers/CreateUpdateThematicLayers.vue";
import ThematicLayers from "./vue/src/Maps/ThematicLayers/ThematicLayers.vue";
import BicPlanta from "./vue/src/Components/MapActions/Bic/BicPlanta.vue";
import AssessedValue from "./vue/src/Components/MapActions/Bic/Tabs/AssessedValue.vue";
import MapSwiper from "./vue/src/Maps/MapSwiper.vue";
import ProcedureTypes from "./vue/src/Configurations/ProcedureTypes/ProcedureTypes.vue";
import UpdateProcedureTypes from "./vue/src/Configurations/ProcedureTypes/UpdateProcedureTypes.vue";
import AccessLogs from "./vue/src/Configurations/AccessLogs/AccessLogs.vue";
import Personalization from "./vue/src/Configurations/Personalizations/Personalization.vue";
import DataDictionary from "./vue/src/Configurations/DataDictionary/DataDictionary.vue";
import PlantaLote from "./vue/src/Maps/PlantaLote.vue";
import PlantaQuadra from "./vue/src/Maps/PlantaQuadra.vue";
import Cemeteries from "./vue/src/Cemeteries/Cemeteries.vue";
import SepultureTypes from "./vue/src/Cemeteries/SepultureTypes.vue";
import Sinter from "./vue/src/Sinter/Sinter.vue";
import SinterTabelasCodigo from "./vue/src/Sinter/TabelasCodigo.vue";
import PhysicalPeople from "./vue/src/Register/PhysicalPeople.vue";
import LegalPeople from "./vue/src/Register/LegalPeople.vue";
import ServicesAndActivities from "./vue/src/MapsOpenLayers/Components/ServicesAndActivities.vue";
import Audit from "./vue/src/Components/MapActions/Bic/Audit.vue";
import PropertyCadastralAudit from "./vue/src/Components/MapActions/PropertyCadastralAudit.vue";
import Foto360 from "./vue/src/Components/MapActions/Foto360.vue";
import MapEditor from "./vue/src/Maps/MapEditor.vue";

const vfm = createVfm()
const app = createApp({});

app.use(vfm)
app.use(Antd, { locale: ptBR })
app.use(VueTheMask)
app.component('vistoriar', Vistoriar);
app.component('vistorias', Vistoria);
app.component('vistoria-old', VistoriaOld);
app.component('show-vistorias', ShowVistorias)
app.component('create-update-vistoria', CreateUpdateVistoria);
app.component('vistoria-card', VistoriaCard);
app.component('schedule-vistoria', ScheduleVistoria);
app.component('doc-configure', DocConfiguration);
app.component('docs', Docs);
app.component('doc-emissao', DocEmissao);
app.component('doc-history', DocHistory);
app.component('zoneamento', Zoneamento);
app.component('usos-solo', UsosSolo);
app.component('create-update-usos-solo', CreateUpdateUsosSolo);
app.component('view-html-usos-solo', ViewHtmlUsosSolo);
app.component('siglas', Siglas);
app.component('create-update-siglas', CreateUpdateSiglas);
app.component('view-html-siglas', ViewHtmlSiglas);
app.component('ocupacoes-solo', OcupacoesSolo);
app.component('create-update-ocupacoes-solo', CreateUpdateOcupacoesSolo);
app.component('view-html-ocupacoes-solo', ViewHtmlOcupacoesSolo);
app.component('browser', Browser)
app.component('table-view', TableView)
app.component('vue-menu', VueMenu)
app.component('menus', Menus)
app.component('users', Users)
app.component('create-update-users', CreateUpdateUser);
app.component('change-password', ChangePassword);
app.component('login', Login);
app.component('users-groups', UsersGroups);
app.component('create-update-groups-users', CreateUpdateGroupsUsers);
app.component('faq', FAQ);
app.component('create-update-faqs', CreateUpdateFAQs);
app.component('client-images', ClientImages);
app.component('create-update-client-images', CreateUpdateClientImages);
app.component('view-bic', Bic);
app.component("home", Home)
app.component("welcome-map", WelcomeMap)
app.component("viability-map", ViabilityMap)
app.component('types-service', TypesService);
app.component('create-update-types-service', CreateUpdateTypesService);
app.component('street-view', StreetView)
app.component('specific-functionalities', SpecificFunctionalities)
app.component('layers', Layers)
app.component('create-update-layers', CreateUpdateLayers)
app.component('layer-viewer', LayerViewer)
app.component('public-layer-viewer', PublicLayerViewer)
app.component('create-update-thematic-layers', CreateUpdateThematicLayers)
app.component('thematic-layers', ThematicLayers)
app.component('bic-planta', BicPlanta)
app.component('assessed-value', AssessedValue)
app.component('map-swiper', MapSwiper)
app.component('procedure-types', ProcedureTypes)
app.component('update-procedure-types', UpdateProcedureTypes)
app.component('access-logs', AccessLogs)
app.component('personalization', Personalization)
app.component('data-dictionary', DataDictionary)
app.component('planta-lote', PlantaLote)
app.component('planta-quadra', PlantaQuadra)
app.component('cemeteries', Cemeteries)
app.component('sepulture-types', SepultureTypes)
app.component('sinter', Sinter)
app.component('sinter-tabelas-codigo', SinterTabelasCodigo)
app.component('physical-people', PhysicalPeople)
app.component('legal-people', LegalPeople)
app.component('services-and-activities', ServicesAndActivities)
app.component('auditoria', Audit)
app.component('property-cadastral-audit', PropertyCadastralAudit)
app.component('foto360', Foto360)
app.component('map-editor', MapEditor)


app.use(InstallCodeMirror);
app.config.globalProperties.$http = axios;
app.mount('#main');